/**
 * PersonalPanel — dedicated view for every transaction the operator has
 * classified as "personal". Thin wrapper around FlaggedPanel.
 */
import { User, TrendingDown } from "lucide-react";
import FlaggedPanel from "./FlaggedPanel";

export default function PersonalPanel(props) {
  return (
    <FlaggedPanel
      {...props}
      filter={{ category: "personal" }}
      title="Personal expenses"
      subtitle="Every transaction you flagged as personal, in one place."
      icon={User}
      iconBgClass="bg-brand-navy"
      totalLabel="Total personal"
      testidPrefix="ops-personal"
      loadErrorText="Failed to load personal transactions"
      emptyIcon={TrendingDown}
      emptyTitle="No personal expenses yet"
      emptyBody={<>Mark any transaction&apos;s category as <span className="font-semibold text-brand-navy">Personal</span> in the Review tab and it will show up here.</>}
      showCostCentre={false}
    />
  );
}
